import CitySEOHead from "@/components/feature/CitySEOHead";
import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import ServicesSection from "./components/ServicesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import LocalAreaSection from "./components/LocalAreaSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import FAQSection from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FinalCTA from "./components/FinalCTA";

const faqs = [
  { q: "How do I get an expedited passport in Rapid City, South Dakota?", a: "Rapid City residents can use Fast Passport Center for 2-9 day expedited processing. Submit your application, visit a local acceptance facility, then ship documents overnight. We handle agency submission — no trip to Denver required." },
  { q: "Where is the nearest passport agency to Rapid City?", a: "The Denver Regional Passport Agency (1961 Stout St, Denver, CO) is approximately 360 miles south of Rapid City via I-90 and I-25. It requires an appointment for genuine emergencies only. Fast Passport Center eliminates that drive." },
];

export default function RapidCityPage() {
  return (
    <div className="min-h-screen bg-white">
      <CitySEOHead
        city="Rapid City"
        state="South Dakota"
        stateAbbr="SD"
        route="/cities/rapid-city"
        title="Emergency Passport Rapid City, SD — Expedited & Fast Passport Service | Fast Passport Center"
        description="Fast Passport Center provides emergency, expedited, and same-day passport services in Rapid City, South Dakota. Serving Pennington County, Black Hills, Box Elder, Sturgis, and Spearfish. As fast as 24 hours — no Denver agency trip needed."
        geoPlacename="Rapid City, South Dakota"
        geoPosition="44.0805;-103.2310"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="South Dakota"
        statePageRoute="/states/south-dakota"
      />
      <HeroSection />
      <StickyNav />
      <ProcessingTimeSection />
      <ServicesSection />
      <HowItWorksSection />
      <LocalAreaSection />
      <TestimonialsSection />
      <AcceptanceFacilitiesSection />
      <ComparisonSection />
      <MistakesSection />
      <FAQSection />
      <HelpfulResourcesSection />
      <FinalCTA />
    </div>
  );
}